<template lang="pug">
.showAddressMap(style='width:100%;height:100%;',:id='mapid') 

</template>
<script>
export default {
  name: "showAddressMapCom",
  props: {
    mapid: {
      type: String,
      default: ""
    },
    labeltype: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    longitude: {
      type: String,
      default: ""
    },
    latitude: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    ininFunc() {
      if (this.mapid) {
        this[this.mapid] = {
          mapcontainer: null,
          mapmarker: null,
          geolocation: null
        };

        this.$nextTick(() => {
          // this.viewMapTemp = true
          if (document.getElementById(this.mapid)) {
            this.mapInit(this.mapid);
          }
        });
      }
    },
    rebackFunc() {
      // console.log(this.baseForm);
      this.$emit("fun", this.baseForm);
    },
    setmarkerFunc(longitude, latitude) {
      let mapObjs = this[this.mapid];
      if (mapObjs.mapmarker) {
        mapObjs.mapmarker.setPosition([longitude, latitude]);
      }
      if (mapObjs.mapcontainer) {
        mapObjs.mapcontainer.add(mapObjs.mapmarker);
        mapObjs.mapcontainer.setFitView(mapObjs.mapmarker);
      }
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      let mapObjs = this[containerId];
      mapObjs.mapcontainer = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18
      });

      mapObjs.mapmarker = new AMap.Marker({
        // position: [this.longitude, this.latitude],
        map: mapObjs.mapcontainer,
        // content: markerContent,
        // 以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-13, -30)
      });

      let markerContent =
        "" +
        '<div class="custom-content-marker">' +
        '     <img src="https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png">' +
        '     <div class="custom-content-marker_box">' +
        '         <div class="label_text"  > ' +
        "扫码人" +
        "          </div>" +
        '       <div class=""  >' +
        this.address +
        "</div>" +
        "     </div>" +
        "</div>";

      mapObjs.mapmarker.setContent(markerContent);

      if (this.longitude && this.latitude) {
        this.setmarkerFunc(this.longitude, this.latitude);
      } else {
        mapObjs.mapcontainer.plugin("AMap.Geolocation", () => {
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000 //超过10秒后停止定位，默认：无穷大
            // buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            // zoomToAccuracy: false, //定位区域
            // buttonPosition: "RB"
          });
          mapObjs.mapcontainer.addControl(geolocation);
          geolocation.getCurrentPosition();

          AMap.event.addListener(geolocation, "complete", data => {
            this.setmarkerFunc(data.position.getLng(), data.position.getLat());
          }); //返回定位信息
        });
      }
    }
  },
  mounted() {
    this.ininFunc();
  },
  watch: {
    mapid(val) {
      if (val) {
        this.ininFunc();
      }
    },
    longitude(val) {
      if (val) {
        this.setmarkerFunc(this.longitude, this.latitude);
      }
    }
  }
};
</script>
<style lang="less">
.showAddressMap {
  .custom-content-marker {
    position: relative;
    .custom-content-marker_box {
      font-size: 12px;
      position: absolute;
      left: -150px;
      bottom: 40px;
      width: 300px;
      background-color: #fff;
      border-radius: 3px;
      -webkit-box-shadow: 0px 0px 5px #d6d6d6;
      box-shadow: 0px 0px 5px #d6d6d6;
      padding: 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: 20px;
      .label_text {
        font-weight: bold;
        padding-bottom: 5px;
      }
    }
  }
}
</style>